var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVaults = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 3.75H3.75v12.5h12.5V3.75ZM3.75 2.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25h.625c0 .345.28.625.625.625h1.667c.345 0 .625-.28.625-.625h5.416c0 .345.28.625.625.625H15c.345 0 .625-.28.625-.625h.625c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H3.75Zm4.914 6.184c-.333.339-.539.803-.539 1.316a1.869 1.869 0 0 0 .55 1.325l.007.008.007.007c.338.331.8.535 1.311.535a1.87 1.87 0 0 0 1.325-.55l.016-.015c.33-.338.534-.8.534-1.31 0-.512-.205-.976-.538-1.314l-.011-.012-.012-.011A1.869 1.869 0 0 0 10 8.125c-.513 0-.978.206-1.316.54l-.01.01-.01.009Zm3.06-1.291a3.107 3.107 0 0 0-1.099-.455V5.833a.625.625 0 1 0-1.25 0v1.105c-.399.08-.77.238-1.098.455l-.781-.781a.625.625 0 0 0-.884.884l.78.78c-.217.329-.373.7-.454 1.099H5.833a.625.625 0 0 0 0 1.25h1.105c.08.399.238.77.455 1.098l-.78.781a.625.625 0 0 0 .883.884l.78-.78c.329.216.7.373 1.099.454v1.105a.625.625 0 0 0 1.25 0v-1.104c.399-.082.77-.239 1.098-.456l.78.78a.625.625 0 1 0 .885-.883l-.78-.78c.216-.329.373-.7.454-1.099h1.105a.625.625 0 0 0 0-1.25h-1.104a3.108 3.108 0 0 0-.456-1.098l.781-.781a.625.625 0 1 0-.884-.884l-.78.78ZM10 10.833a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Z",
    fill: "#fff"
  })));
};
export default SvgVaults;